import type * as React from "react";

import { Button } from "~/components/ui/button";

import type { ContentCard as ContentCardType } from "./types";
import { overlayPositionClasses } from "./utils";

interface ContentCardProps extends ContentCardType {
  index?: number;
  totalCards?: number;
}

export const ContentCard = (props: ContentCardProps) => {
  const backgroundType = props.backgroundImageType || "color";
  const urlLink = props.external
    ? (props.external_link?.value?.data?.url ?? "#")
    : (props.link?.value?.data?.url ?? "#");

  const bgStyle: React.CSSProperties = {
    backgroundImage:
      backgroundType === "image" ? `url(${props.backgroundImage})` : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundColor:
      backgroundType === "color" ? props.backgroundColor : "transparent",
  };

  const overlayPositionClass =
    overlayPositionClasses[props.overlayImagePosition || "center"] ||
    overlayPositionClasses.center;

  return (
    <div className="flex w-[170px] flex-col gap-0 sm:h-[319px] sm:w-[190px] md:w-[230px] lg:h-[528px] lg:w-[315px] xl:w-[396px]">
      <div className="relative h-full w-full" style={bgStyle}>
        {props.overlayImage && (
          <img
            src={props.overlayImage}
            alt="Overlay"
            className={`absolute max-h-[50px] max-w-[64px] object-contain lg:max-w-[150px] ${overlayPositionClass}`}
          />
        )}
      </div>
      <Button
        as="a"
        href={urlLink}
        className="flex h-[48px] w-full items-center justify-center rounded-none text-[18px] text-white lg:h-[60px] lg:text-[24px]"
        data-testid="content-card-cta"
      >
        {props.ctaText || "Learn More"}
      </Button>
    </div>
  );
};
